import axios from 'axios';
import conf from './../configs/config';
import { toast } from 'react-toastify';
// import logger from './logService';

// ---- To set cookie from server, withCredentials should be set true
axios.defaults.withCredentials = true;

// ---- Request interceptor for API calls
axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ---- Response interceptor for API calls

function createAxiosResponseInterceptor() {
  const interceptor = axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      // Throw unexpected error for >= 400 and < 500
      if (error.response && error.response.status !== 401) {
        const expectedError = error.response.status >= 400 && error.response.status < 500;
        if (!expectedError) toast.error('An unexpected error occured');
        return Promise.reject(error);
      }
      /*
       * When response code is 401, try to refresh the token.
       * Eject the interceptor so it doesn't loop in case
       * token refresh causes the 401 response.
       *
       * Must be re-attached later on or the token refresh will only happen once
       */
      if (
        error.response &&
        error.response.status === 401 &&
        !window.location.href.includes('login')
      ) {
        axios.interceptors.response.eject(interceptor);
        try {
          await axios.post(conf.apiEndPoint + '/refresh');
          return axios(error.response.config);
        } catch (refreshError) {
          if (!localStorage.getItem('session_alert')) {
            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem('session_alert', 'yes');
            toast.error(
              'Alert: Your session might have expired. Refresh your screen to check and login again'
            );
          }
          return Promise.reject(refreshError);
        } finally {
          createAxiosResponseInterceptor();
        }
      }
      return Promise.reject(error);
    }
  );
}
createAxiosResponseInterceptor();

// ---- sets auth header
function setJwt(jwt) {
  if (jwt) axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt
};
